import { useAppSelector } from 'app/hooks';
import Button, { ButtonWrapper } from 'blocks/Button';
import Breadcrumb from 'components/Breadcrumb';
import Form, { DatePicker, InputWrapper, SelectField, TextField } from 'components/Form';
import TermsCondition from 'components/TermsCondition';
import ROUTES from 'config/routes-constant';
import { getDate, getTimeStamp } from 'helper/date';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import DepartureArrivalField from 'pages/services/FreeTicket/form/components/flightForm/departureArrivalField';
import { callbackPropsDepartureArrivalField } from 'pages/services/FreeTicket/form/components/flightForm/departureArrivalField/departureArrivalField.interface';
import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { isLTRState } from 'store/options/optionsSlice';
import ajax from 'utils/ajax';
import { CABIN_CLASS } from 'utils/constants';
import urls from 'utils/urls';
import { NewMilageFormModel } from './mailsNew.interface';
import * as S from './mailsNew.style';

const NewMilage = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm<NewMilageFormModel>();
  const isLTR = useAppSelector(isLTRState);

  const changeArrivalDeparture = (data: callbackPropsDepartureArrivalField) => {
    if (data.departure) {
      setValue('departure', data.departure.code);
    }
    if (data.arrival) {
      setValue('destination', data.arrival.code);
    }
  };

  const breadcrumbLinks = [
    { title: t(`pageTitles.${Paths.Dashboard.index().name}`), url: Paths.Dashboard.index().route, active: false },
    { title: t(`pageTitles.${Paths.Miles.claim().name}`), url: Paths.Miles.claim().route, active: false },
    { title: t(`pageTitles.${Paths.Miles.new().name}`), url: Paths.Miles.new().route, active: false },
  ] as BreadcrumbInterface[];

  const selectedCabinClass = useRef('');
  const termsCondition = [];

  let howToIndex = 1;
  const howToListKeyPath = 'pages.miles.new.sections.howTo.list.';
  while (!t(`${howToListKeyPath}${howToIndex}`).includes(`${howToListKeyPath}${howToIndex}`)) {
    termsCondition.push(t(`${howToListKeyPath}${howToIndex}`));
    howToIndex++;
  }
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState('');

  const registerFlight = async () => {
    const { eTicketNumber, departure, destination, flightNo, cabinClass, flightDate, PNR } = getValues();

    setLoading(true);

    const data = {
      eTicketNumber,
      PNR,
      departure,
      destination,
      RDB: selectedCabinClass.current,
      flightNo,
      cabinClass,
      flightDate: getTimeStamp(flightDate, 'YYYY-MM-DD'),
    };

    await ajax({
      url: urls.registerFlight,
      method: 'POST',
      data,
      showNotif: true,
    }).finally(() => setLoading(false));

    setRedirect(ROUTES.claimMiles);
  };

  if (redirect) return <Navigate to={redirect} />;

  return (
    <WithSidebar>
      <S.NewMilesPage>
        <Breadcrumb links={breadcrumbLinks} title={t('pages.miles.new.title')} />

        <S.NewBoxWrapper>
          <S.NewBoxLeft>
            <S.NewForm as={Form}>
              <InputWrapper>
                <DatePicker
                  label={t('pages.miles.new.sections.form.fields.flightDate.label')}
                  minDate={new Date().getTime()}
                  defaultValue={getDate(getValues('flightDate'))}
                  onChange={(date) => setValue('flightDate', date)}
                />
              </InputWrapper>
              <InputWrapper>
                <DepartureArrivalField onChange={(data) => changeArrivalDeparture(data)} />
              </InputWrapper>
              {/* <InputWrapper>
                <SelectField
                  control={register('departure')}
                  label={t('pages.miles.new.sections.form.fields.from.label')}
                  error={errors.departure}
                  placeholder={t('pages.miles.new.sections.form.fields.from.placeholder')}
                  onChange={(value: string) => setValue('departure', value)}
                  apiUrl={urls.departureRoute}
                  requestOnce
                  autoCompelete
                />
              </InputWrapper>
              <InputWrapper>
                <SelectField
                  control={register('destination')}
                  label={t('pages.miles.new.sections.form.fields.to.label')}
                  error={errors.destination}
                  placeholder={t('pages.miles.new.sections.form.fields.to.placeholder')}
                  onChange={(value: string) => setValue('destination', value)}
                  apiUrl={urls.destinationRoute(watch('departure'))}
                  autoCompelete
                />
              </InputWrapper> */}

              <InputWrapper>
                <TextField
                  control={register('flightNo')}
                  label={t('pages.miles.new.sections.form.fields.flightNumber.label')}
                />
                <SelectField
                  label={t('pages.miles.new.sections.form.fields.cabinClass.label')}
                  onChange={(value: string) => setValue('cabinClass', value)}
                  menu={CABIN_CLASS}
                  onSelect={(objectValue: any) => (selectedCabinClass.current = objectValue.RBD)}
                  defaultValue={getValues('cabinClass')}
                />
              </InputWrapper>
              <S.PNRAndTicketNumberParent>
                <InputWrapper>
                  <TextField
                    control={register('PNR')}
                    label={t('pages.miles.new.sections.form.fields.bookingRef.label')}
                  />
                </InputWrapper>

                <InputWrapper>
                  <TextField
                    control={register('eTicketNumber')}
                    label={t('pages.miles.new.sections.form.fields.ticketNumber.label')}
                  />
                </InputWrapper>
              </S.PNRAndTicketNumberParent>

              <S.ButtonWrapper as={ButtonWrapper} justify="center">
                <S.NewBoxLeftButton as={Button} loading={loading} onClick={() => registerFlight()}>
                  {t('pages.miles.new.sections.form.submitCTA')}
                </S.NewBoxLeftButton>
              </S.ButtonWrapper>
            </S.NewForm>
          </S.NewBoxLeft>

          <S.NewBoxRight>
            <TermsCondition title={t('pages.miles.new.sections.howTo.title')} termsItem={termsCondition} />
          </S.NewBoxRight>
        </S.NewBoxWrapper>
      </S.NewMilesPage>
    </WithSidebar>
  );
};

export default NewMilage;
